export const DAYPARTING_TAB = 'hourly-budget';

export const DAYPARTING_SCOPE_CHIPS = [
  'Bid snapshots',
  'Dayparting',
  'Portfolios (Soon)',
] as const;

export function isDaypartingTab(tab: string | null | undefined): boolean {
  return tab === DAYPARTING_TAB;
}

export function daypartingSearchParams(tab: string): Record<string, string> {
  if (tab === DAYPARTING_TAB) return { tab: DAYPARTING_TAB };
  return { tab };
}
